import { Facebook, Instagram } from "lucide-react";
import { SOCIAL_LINKS } from "../data/content";

const GoogleIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M21.35 11.1h-9.17v2.73h6.51c-.33 3.81-3.5 5.44-6.5 5.44C8.36 19.27 5 16.25 5 12c0-4.1 3.2-7.27 7.2-7.27 3.09 0 4.9 1.97 4.9 1.97L19 4.72S16.56 2 12.1 2C6.42 2 2.03 6.8 2.03 12c0 5.05 4.13 10 10.22 10 5.35 0 9.25-3.67 9.25-9.09 0-1.15-.15-1.81-.15-1.81z" />
  </svg>
);

const icons = { Google: GoogleIcon, Facebook, Instagram };

export const SocialLinks = ({ size = "h-5 w-5", className = "" }) => (
  <div className={`flex items-center gap-3 ${className}`} data-testid="social-links">
    {SOCIAL_LINKS.map((s) => {
      const Icon = icons[s.name];
      return (
        <a
          key={s.name}
          data-testid={`social-link-${s.name.toLowerCase()}`}
          href={s.url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`Mason's Mobile Mechanic on ${s.name}`}
          className="border border-zinc-700 hover:border-blue-500 hover:text-blue-400 text-zinc-300 rounded-sm p-2.5 transition-colors"
        >
          <Icon className={size} />
        </a>
      );
    })}
  </div>
);
